unit View.Nfce.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewNfceEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbchave_acesso: TLabel;
    edchave_acesso: TDBEdit;
    lbdata_transmissao: TLabel;
    eddata_transmissao: TDBEdit;
    lbnfce_cancelada: TLabel;
    ednfce_cancelada: TDBEdit;
    lbnfce_xml_s3: TLabel;
    ednfce_xml_s3: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    lbserie: TLabel;
    edserie: TDBEdit;
    lbnumero: TLabel;
    ednumero: TDBEdit;
    XDataClientNfceGet: TXDataWebClient;
    XDataClientNfceDelete: TXDataWebClient;
    NfceDataset: TXDataWebDataSet;
    NfceDatasetid: TIntegerField;
    NfceDatasetaliado_id: TIntegerField;
    NfceDatasetdata_base_id: TIntegerField;
    NfceDatasetchave_acesso: TStringField;
    NfceDatasetdata_transmissao: TDateTimeField;
    NfceDatasetnfce_cancelada: TBooleanField;
    NfceDatasetnfce_xml_s3: TStringField;
    NfceDatasetcodigo_interno: TIntegerField;
    NfceDatasetexcluido: TBooleanField;
    NfceDatasetinclusao: TDateTimeField;
    NfceDatasetalteracao: TDateTimeField;
    NfceDatasetexclusao: TDateTimeField;
    NfceDatasetserie: TIntegerField;
    NfceDatasetnumero: TStringField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientNfceGetLoad(Response: TXDataClientResponse);
    procedure XDataClientNfceDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientNfceDeleteError(Error: TXDataClientError);
    procedure NfceDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfceEdit: TFViewNfceEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfceEdit }

procedure TFViewNfceEdit.btSaveClick(Sender: TObject);
begin
  if NfceDataset.State in dsEditModes then
  begin
        NfceDataset.Post;
    NfceDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewNfceEdit.btDeleteClick(Sender: TObject);
begin
  if NfceDataset.State in dsEditModes then
    NfceDataset.Post;
  XDataClientNfceDelete.Delete(NfceDataset.EntitySetName,
    TJSObject(NfceDataset.CurrentData));
end;


class function TFViewNfceEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewNfceEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewNfceEdit.InsertEntity;
begin
  NfceDataset.Close;
  NfceDataset.SetJsonData('{}');
  NfceDataset.Open;
  NfceDataset.Insert;
end;

class function TFViewNfceEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfceEdit(AForm).FInserting := AInserting;
    TFViewNfceEdit(AForm).FId := AId;
    TFViewNfceEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewNfceEdit(AForm).InsertEntity
    else
      TFViewNfceEdit(AForm).LoadEntity;
    TFViewNfceEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewNfceEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfceEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    NfceDataset.Connection.Model.DefaultSchema.FindEntityType(
      NfceDataset.EntitySetName
    )
  );
  XDataClientNfceGet.Get(NfceDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewNfceEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewNfceEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewNfceEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewNfceEdit.XDataClientNfceGetLoad(Response: TXDataClientResponse);
begin
  NfceDataset.Close;
  NfceDataset.SetJsonData(Response.Result);
  NfceDataset.Open;
  
  NfceDataset.Edit;  
end;

procedure TFViewNfceEdit.XDataClientNfceDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewNfceEdit.XDataClientNfceDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewNfceEdit.NfceDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewNfceEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewNfceEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.nfce.form.message');
  lbMessage := TLabel.Create('view.nfce.form.message.label');
  btCloseMessage := TButton.Create('view.nfce.form.message.button');
  btCancel := TButton.Create('view.nfce.form.btBack');
  btSave := TButton.Create('view.nfce.form.btSave');
  btDelete := TButton.Create('view.nfce.form.btDelete');
  lbid := TLabel.Create('view.nfce.form.lbid');
  edid := TDBEdit.Create('view.nfce.form.edid');
  lbaliado_id := TLabel.Create('view.nfce.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.nfce.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.nfce.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.nfce.form.eddata_base_id');
  lbchave_acesso := TLabel.Create('view.nfce.form.lbchave_acesso');
  edchave_acesso := TDBEdit.Create('view.nfce.form.edchave_acesso');
  lbdata_transmissao := TLabel.Create('view.nfce.form.lbdata_transmissao');
  eddata_transmissao := TDBEdit.Create('view.nfce.form.eddata_transmissao');
  lbnfce_cancelada := TLabel.Create('view.nfce.form.lbnfce_cancelada');
  ednfce_cancelada := TDBEdit.Create('view.nfce.form.ednfce_cancelada');
  lbnfce_xml_s3 := TLabel.Create('view.nfce.form.lbnfce_xml_s3');
  ednfce_xml_s3 := TDBEdit.Create('view.nfce.form.ednfce_xml_s3');
  lbcodigo_interno := TLabel.Create('view.nfce.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.nfce.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.nfce.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.nfce.form.edexcluido');
  lbinclusao := TLabel.Create('view.nfce.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.nfce.form.edinclusao');
  lbalteracao := TLabel.Create('view.nfce.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.nfce.form.edalteracao');
  lbexclusao := TLabel.Create('view.nfce.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.nfce.form.edexclusao');
  lbserie := TLabel.Create('view.nfce.form.lbserie');
  edserie := TDBEdit.Create('view.nfce.form.edserie');
  lbnumero := TLabel.Create('view.nfce.form.lbnumero');
  ednumero := TDBEdit.Create('view.nfce.form.ednumero');
  DataSource := TDataSource.Create(Self);
  NfceDataset := TXDataWebDataSet.Create(Self);
  NfceDatasetid := TIntegerField.Create(Self);
  NfceDatasetaliado_id := TIntegerField.Create(Self);
  NfceDatasetdata_base_id := TIntegerField.Create(Self);
  NfceDatasetchave_acesso := TStringField.Create(Self);
  NfceDatasetdata_transmissao := TDateTimeField.Create(Self);
  NfceDatasetnfce_cancelada := TBooleanField.Create(Self);
  NfceDatasetnfce_xml_s3 := TStringField.Create(Self);
  NfceDatasetcodigo_interno := TIntegerField.Create(Self);
  NfceDatasetexcluido := TBooleanField.Create(Self);
  NfceDatasetinclusao := TDateTimeField.Create(Self);
  NfceDatasetalteracao := TDateTimeField.Create(Self);
  NfceDatasetexclusao := TDateTimeField.Create(Self);
  NfceDatasetserie := TIntegerField.Create(Self);
  NfceDatasetnumero := TStringField.Create(Self);
  XDataClientNfceGet := TXDataWebClient.Create(Self);
  XDataClientNfceDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbchave_acesso.BeforeLoadDFMValues;
  edchave_acesso.BeforeLoadDFMValues;
  lbdata_transmissao.BeforeLoadDFMValues;
  eddata_transmissao.BeforeLoadDFMValues;
  lbnfce_cancelada.BeforeLoadDFMValues;
  ednfce_cancelada.BeforeLoadDFMValues;
  lbnfce_xml_s3.BeforeLoadDFMValues;
  ednfce_xml_s3.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  lbserie.BeforeLoadDFMValues;
  edserie.BeforeLoadDFMValues;
  lbnumero.BeforeLoadDFMValues;
  ednumero.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  NfceDataset.BeforeLoadDFMValues;
  NfceDatasetid.BeforeLoadDFMValues;
  NfceDatasetaliado_id.BeforeLoadDFMValues;
  NfceDatasetdata_base_id.BeforeLoadDFMValues;
  NfceDatasetchave_acesso.BeforeLoadDFMValues;
  NfceDatasetdata_transmissao.BeforeLoadDFMValues;
  NfceDatasetnfce_cancelada.BeforeLoadDFMValues;
  NfceDatasetnfce_xml_s3.BeforeLoadDFMValues;
  NfceDatasetcodigo_interno.BeforeLoadDFMValues;
  NfceDatasetexcluido.BeforeLoadDFMValues;
  NfceDatasetinclusao.BeforeLoadDFMValues;
  NfceDatasetalteracao.BeforeLoadDFMValues;
  NfceDatasetexclusao.BeforeLoadDFMValues;
  NfceDatasetserie.BeforeLoadDFMValues;
  NfceDatasetnumero.BeforeLoadDFMValues;
  XDataClientNfceGet.BeforeLoadDFMValues;
  XDataClientNfceDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewNfceEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 643;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 583;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 583;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 583;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbchave_acesso.SetParentComponent(Self);
    lbchave_acesso.Name := 'lbchave_acesso';
    lbchave_acesso.Left := 24;
    lbchave_acesso.Top := 273;
    lbchave_acesso.Width := 14;
    lbchave_acesso.Height := 13;
    lbchave_acesso.Caption := 'chave_acesso:';
    lbchave_acesso.Transparent := True;
    edchave_acesso.SetParentComponent(Self);
    edchave_acesso.Name := 'edchave_acesso';
    edchave_acesso.Left := 221;
    edchave_acesso.Top := 270;
    edchave_acesso.Width := 200;
    edchave_acesso.Height := 21;
    edchave_acesso.Enabled := True;
    edchave_acesso.TabOrder := 9;
    edchave_acesso.Text := 'edchave_acesso';
    edchave_acesso.DataField := 'chave_acesso';
    edchave_acesso.DataSource := DataSource;
    lbdata_transmissao.SetParentComponent(Self);
    lbdata_transmissao.Name := 'lbdata_transmissao';
    lbdata_transmissao.Left := 24;
    lbdata_transmissao.Top := 300;
    lbdata_transmissao.Width := 14;
    lbdata_transmissao.Height := 13;
    lbdata_transmissao.Caption := 'data_transmissao:';
    lbdata_transmissao.Transparent := True;
    eddata_transmissao.SetParentComponent(Self);
    eddata_transmissao.Name := 'eddata_transmissao';
    eddata_transmissao.Left := 221;
    eddata_transmissao.Top := 297;
    eddata_transmissao.Width := 200;
    eddata_transmissao.Height := 21;
    eddata_transmissao.Enabled := True;
    eddata_transmissao.TabOrder := 10;
    eddata_transmissao.Text := 'eddata_transmissao';
    eddata_transmissao.DataField := 'data_transmissao';
    eddata_transmissao.DataSource := DataSource;
    lbnfce_cancelada.SetParentComponent(Self);
    lbnfce_cancelada.Name := 'lbnfce_cancelada';
    lbnfce_cancelada.Left := 24;
    lbnfce_cancelada.Top := 327;
    lbnfce_cancelada.Width := 14;
    lbnfce_cancelada.Height := 13;
    lbnfce_cancelada.Caption := 'nfce_cancelada:';
    lbnfce_cancelada.Transparent := True;
    ednfce_cancelada.SetParentComponent(Self);
    ednfce_cancelada.Name := 'ednfce_cancelada';
    ednfce_cancelada.Left := 221;
    ednfce_cancelada.Top := 324;
    ednfce_cancelada.Width := 200;
    ednfce_cancelada.Height := 21;
    ednfce_cancelada.Enabled := True;
    ednfce_cancelada.TabOrder := 11;
    ednfce_cancelada.Text := 'ednfce_cancelada';
    ednfce_cancelada.DataField := 'nfce_cancelada';
    ednfce_cancelada.DataSource := DataSource;
    lbnfce_xml_s3.SetParentComponent(Self);
    lbnfce_xml_s3.Name := 'lbnfce_xml_s3';
    lbnfce_xml_s3.Left := 24;
    lbnfce_xml_s3.Top := 354;
    lbnfce_xml_s3.Width := 14;
    lbnfce_xml_s3.Height := 13;
    lbnfce_xml_s3.Caption := 'nfce_xml_s3:';
    lbnfce_xml_s3.Transparent := True;
    ednfce_xml_s3.SetParentComponent(Self);
    ednfce_xml_s3.Name := 'ednfce_xml_s3';
    ednfce_xml_s3.Left := 221;
    ednfce_xml_s3.Top := 351;
    ednfce_xml_s3.Width := 200;
    ednfce_xml_s3.Height := 21;
    ednfce_xml_s3.Enabled := True;
    ednfce_xml_s3.TabOrder := 12;
    ednfce_xml_s3.Text := 'ednfce_xml_s3';
    ednfce_xml_s3.DataField := 'nfce_xml_s3';
    ednfce_xml_s3.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 381;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 378;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 13;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 408;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 405;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 14;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 435;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 432;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 15;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 462;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 459;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 16;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 489;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 486;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 17;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    lbserie.SetParentComponent(Self);
    lbserie.Name := 'lbserie';
    lbserie.Left := 24;
    lbserie.Top := 516;
    lbserie.Width := 14;
    lbserie.Height := 13;
    lbserie.Caption := 'serie:';
    lbserie.Transparent := True;
    edserie.SetParentComponent(Self);
    edserie.Name := 'edserie';
    edserie.Left := 221;
    edserie.Top := 513;
    edserie.Width := 200;
    edserie.Height := 21;
    edserie.Enabled := True;
    edserie.TabOrder := 18;
    edserie.Text := 'edserie';
    edserie.DataField := 'serie';
    edserie.DataSource := DataSource;
    lbnumero.SetParentComponent(Self);
    lbnumero.Name := 'lbnumero';
    lbnumero.Left := 24;
    lbnumero.Top := 543;
    lbnumero.Width := 14;
    lbnumero.Height := 13;
    lbnumero.Caption := 'numero:';
    lbnumero.Transparent := True;
    ednumero.SetParentComponent(Self);
    ednumero.Name := 'ednumero';
    ednumero.Left := 221;
    ednumero.Top := 540;
    ednumero.Width := 200;
    ednumero.Height := 21;
    ednumero.Enabled := True;
    ednumero.TabOrder := 19;
    ednumero.Text := 'ednumero';
    ednumero.DataField := 'numero';
    ednumero.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := NfceDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    NfceDataset.SetParentComponent(Self);
    NfceDataset.Name := 'NfceDataset';
    NfceDataset.AfterApplyUpdates := NfceDatasetAfterApplyUpdates;
    NfceDataset.EntitySetName := 'Nfce';
    NfceDataset.Connection := DMConnection.ApiConnection;
    NfceDataset.Left := 176;
    NfceDataset.Top := 8;
    NfceDatasetid.SetParentComponent(NfceDataset);
    NfceDatasetid.Name := 'NfceDatasetid';
    NfceDatasetid.FieldName := 'id';
    NfceDatasetid.Required := True;
    NfceDatasetaliado_id.SetParentComponent(NfceDataset);
    NfceDatasetaliado_id.Name := 'NfceDatasetaliado_id';
    NfceDatasetaliado_id.FieldName := 'aliado_id';
    NfceDatasetaliado_id.Required := True;
    NfceDatasetdata_base_id.SetParentComponent(NfceDataset);
    NfceDatasetdata_base_id.Name := 'NfceDatasetdata_base_id';
    NfceDatasetdata_base_id.FieldName := 'data_base_id';
    NfceDatasetdata_base_id.Required := True;
    NfceDatasetchave_acesso.SetParentComponent(NfceDataset);
    NfceDatasetchave_acesso.Name := 'NfceDatasetchave_acesso';
    NfceDatasetchave_acesso.FieldName := 'chave_acesso';
    NfceDatasetchave_acesso.Required := False;
    NfceDatasetchave_acesso.Size := 255;
    NfceDatasetdata_transmissao.SetParentComponent(NfceDataset);
    NfceDatasetdata_transmissao.Name := 'NfceDatasetdata_transmissao';
    NfceDatasetdata_transmissao.FieldName := 'data_transmissao';
    NfceDatasetdata_transmissao.Required := False;
    NfceDatasetnfce_cancelada.SetParentComponent(NfceDataset);
    NfceDatasetnfce_cancelada.Name := 'NfceDatasetnfce_cancelada';
    NfceDatasetnfce_cancelada.FieldName := 'nfce_cancelada';
    NfceDatasetnfce_cancelada.Required := False;
    NfceDatasetnfce_xml_s3.SetParentComponent(NfceDataset);
    NfceDatasetnfce_xml_s3.Name := 'NfceDatasetnfce_xml_s3';
    NfceDatasetnfce_xml_s3.FieldName := 'nfce_xml_s3';
    NfceDatasetnfce_xml_s3.Required := False;
    NfceDatasetnfce_xml_s3.Size := 65536;
    NfceDatasetcodigo_interno.SetParentComponent(NfceDataset);
    NfceDatasetcodigo_interno.Name := 'NfceDatasetcodigo_interno';
    NfceDatasetcodigo_interno.FieldName := 'codigo_interno';
    NfceDatasetcodigo_interno.Required := True;
    NfceDatasetexcluido.SetParentComponent(NfceDataset);
    NfceDatasetexcluido.Name := 'NfceDatasetexcluido';
    NfceDatasetexcluido.FieldName := 'excluido';
    NfceDatasetexcluido.Required := False;
    NfceDatasetinclusao.SetParentComponent(NfceDataset);
    NfceDatasetinclusao.Name := 'NfceDatasetinclusao';
    NfceDatasetinclusao.FieldName := 'inclusao';
    NfceDatasetinclusao.Required := False;
    NfceDatasetalteracao.SetParentComponent(NfceDataset);
    NfceDatasetalteracao.Name := 'NfceDatasetalteracao';
    NfceDatasetalteracao.FieldName := 'alteracao';
    NfceDatasetalteracao.Required := False;
    NfceDatasetexclusao.SetParentComponent(NfceDataset);
    NfceDatasetexclusao.Name := 'NfceDatasetexclusao';
    NfceDatasetexclusao.FieldName := 'exclusao';
    NfceDatasetexclusao.Required := False;
    NfceDatasetserie.SetParentComponent(NfceDataset);
    NfceDatasetserie.Name := 'NfceDatasetserie';
    NfceDatasetserie.FieldName := 'serie';
    NfceDatasetserie.Required := False;
    NfceDatasetnumero.SetParentComponent(NfceDataset);
    NfceDatasetnumero.Name := 'NfceDatasetnumero';
    NfceDatasetnumero.FieldName := 'numero';
    NfceDatasetnumero.Required := False;
    NfceDatasetnumero.Size := 0;
    XDataClientNfceGet.SetParentComponent(Self);
    XDataClientNfceGet.Name := 'XDataClientNfceGet';
    XDataClientNfceGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNfceGet, Self, 'OnLoad', 'XDataClientNfceGetLoad');
    XDataClientNfceGet.Left := 64;
    XDataClientNfceGet.Top := 8;
    XDataClientNfceDelete.SetParentComponent(Self);
    XDataClientNfceDelete.Name := 'XDataClientNfceDelete';
    XDataClientNfceDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNfceDelete, Self, 'OnLoad', 'XDataClientNfceDeleteLoad');
    SetEvent(XDataClientNfceDelete, Self, 'OnError', 'XDataClientNfceDeleteError');
    XDataClientNfceDelete.Left := 64;
    XDataClientNfceDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbchave_acesso.AfterLoadDFMValues;
    edchave_acesso.AfterLoadDFMValues;
    lbdata_transmissao.AfterLoadDFMValues;
    eddata_transmissao.AfterLoadDFMValues;
    lbnfce_cancelada.AfterLoadDFMValues;
    ednfce_cancelada.AfterLoadDFMValues;
    lbnfce_xml_s3.AfterLoadDFMValues;
    ednfce_xml_s3.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    lbserie.AfterLoadDFMValues;
    edserie.AfterLoadDFMValues;
    lbnumero.AfterLoadDFMValues;
    ednumero.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    NfceDataset.AfterLoadDFMValues;
    NfceDatasetid.AfterLoadDFMValues;
    NfceDatasetaliado_id.AfterLoadDFMValues;
    NfceDatasetdata_base_id.AfterLoadDFMValues;
    NfceDatasetchave_acesso.AfterLoadDFMValues;
    NfceDatasetdata_transmissao.AfterLoadDFMValues;
    NfceDatasetnfce_cancelada.AfterLoadDFMValues;
    NfceDatasetnfce_xml_s3.AfterLoadDFMValues;
    NfceDatasetcodigo_interno.AfterLoadDFMValues;
    NfceDatasetexcluido.AfterLoadDFMValues;
    NfceDatasetinclusao.AfterLoadDFMValues;
    NfceDatasetalteracao.AfterLoadDFMValues;
    NfceDatasetexclusao.AfterLoadDFMValues;
    NfceDatasetserie.AfterLoadDFMValues;
    NfceDatasetnumero.AfterLoadDFMValues;
    XDataClientNfceGet.AfterLoadDFMValues;
    XDataClientNfceDelete.AfterLoadDFMValues;
  end;
end;

end.
